// Utility centralizzata per gestire le chiamate API e la scadenza del token

export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

// Wrapper per fetch che gestisce automaticamente gli errori 401
export const authenticatedFetch = async (url, options = {}) => {
  // Aggiungi automaticamente l'header di autorizzazione se non presente
  const headers = {
    ...getAuthHeader(),
    ...options.headers
  };

  const response = await fetch(url, {
    ...options,
    headers
  });

  // Controlla se il token è scaduto (401 Unauthorized)
  if (response.status === 401) {
    console.log('🔒 Token abgelaufen - Weiterleitung zum Login');
    
    // Pulisci il localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Reindirizza al login
    window.location.href = '/login';
    
    // Lancia un errore per fermare l'esecuzione
    throw new Error('Token abgelaufen - Weiterleitung zum Login');
  }

  return response;
};

// Versione semplificata per chiamate che non hanno bisogno di controlli aggiuntivi
export const apiCall = async (url, options = {}) => {
  try {
    const response = await authenticatedFetch(url, options);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    return response;
  } catch (error) {
    if (error.message.includes('Token abgelaufen')) {
      // Il reindirizzamento è già gestito da authenticatedFetch
      return;
    }
    throw error;
  }
};

// Hook per sostituire le chiamate fetch esistenti
export const useAuthenticatedApi = () => {
  return {
    get: (url) => apiCall(url, { method: 'GET' }),
    post: (url, data) => apiCall(url, { 
      method: 'POST', 
      body: JSON.stringify(data) 
    }),
    put: (url, data) => apiCall(url, { 
      method: 'PUT', 
      body: JSON.stringify(data) 
    }),
    delete: (url) => apiCall(url, { method: 'DELETE' }),
    
    // Per FormData (file upload)
    postForm: (url, formData) => apiCall(url, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }, // Solo Authorization per FormData
      body: formData
    })
  };
};
